<template>
    <ul v-if="items">
        <template v-for="(item, i) of items">
            <li v-if="visible(item) && !item.separator" :key="i" :class="[{ 'active-menuitem': activeIndex === i && !item.to && !item.disabled }]" role="none">
                <div v-if="item.items && root === true" class="arrow"></div>
                <router-link v-if="item.to" :to="item.to" :class="[item.class, 'p-ripple', { 'active-route': activeIndex === i, 'p-disabled': item.disabled }]"
                    :style="item.style" @click="onMenuItemClick($event, item, i)" :target="item.target" exact role="menuitem" v-ripple>
                    <i :class="item.icon"></i>
                    <span>{{ item.label }}</span>
                    <i v-if="item.items" class="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>
                    <span v-if="badgeAlertas(item) > 0" class="menuitem-badge menuitem-badge-alerta">{{ badgeAlertas(item) }}</span>
                    <span v-if="badgePendientes(item) > 0" class="menuitem-badge menuitem-badge-pendiente">{{ badgePendientes(item) }}</span>
                </router-link>
                <a v-if="!item.to" :href="item.url || '#'" :style="item.style" :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
                    @click="onMenuItemClick($event, item, i)" :target="item.target" role="menuitem" v-ripple>
                    <i :class="item.icon"></i>
                    <span>{{ item.label }}</span>
                    <span v-if="badgeAlertas(item) > 0" class="menuitem-badge menuitem-badge-alerta">{{ badgeAlertas(item) }}</span>
                    <span v-if="badgePendientes(item) > 0" class="menuitem-badge menuitem-badge-pendiente">{{ badgePendientes(item) }}</span>
                    <i v-if="item.items" class="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>
                </a>
                <transition name="layout-submenu-wrapper">
                    <appsubmenu v-show="activeIndex === i" :items="visible(item) && item.items" @menuitem-click="$emit('menuitem-click', $event)"
                        :alertas="alertas" :pendientes="pendientes"></appsubmenu>
                </transition>
            </li>
            <li class="p-menu-separator" :style="item.style" v-if="visible(item) && item.separator" :key="'separator' + i" role="separator"></li>
        </template>
    </ul>
</template>
<script>
export default {
    name: "appsubmenu",
    props: {
        items: Array,
        alertas: {
            type: Object
        },
        pendientes: {
            type: Object
        },
        root: {
            type: Boolean,
            default: false
        }
    },
    emits: ['menuitem-click'],
    data() {
        return {
            activeIndex: null
        };
    },
    methods: {
        onMenuItemClick(event, item, index) {
            if (item.disabled) {
                event.preventDefault();
                return;
            }

            if (!item.to && !item.url) {
                event.preventDefault();
            }

            //execute command
            if (item.command) {
                item.command({ originalEvent: event, item: item });
            }

            this.activeIndex = index === this.activeIndex ? null : index;

            this.$emit("menuitem-click", {
                originalEvent: event,
                item: item
            });
        },
        visible(item) {
            return typeof item.visible === "function" ? item.visible() : item.visible !== false;
        },
        badgeAlertas(item) {
            if (typeof item.alertas !== 'undefined') {

                let cantidad = 0;

                for (let x = 0; x < item.alertas.length; x++) {
                    const alerta = item.alertas[x];

                    cantidad = cantidad + this.alertas[alerta];

                }

                return cantidad;
            }

            return 0;
        },
        badgePendientes(item) {

            if (typeof item.pendientes !== 'undefined') {


                let cantidad = 0;

                for (let x = 0; x < item.pendientes.length; x++) {
                    const pendiente = item.pendientes[x];

                    cantidad = cantidad + this.pendientes[pendiente];

                }

                return cantidad;
            }

            return 0;
        },
    }
};
</script>

<style lang="scss" scoped>
li a {
    svg {
        flex-shrink: 0;
    }

    span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .menuitem-badge-alerta {
        background-color: var(--pink-600);
        flex-shrink: 0;
        width: 18px;
        height: 18px;
    }

    .menuitem-badge-pendiente {
        background-color: var(--yellow-300);
        color: black;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
    }
}
</style>
